/* OneOpenSky, Størrelsesguide
   Bygger indholdet af <dialog class="oos-sg"> ud fra JSON i data-sg-data.
   Ingen afhængigheder, ingen API-kald, intet token. */
(function () {
  var L = {bryst:'Bryst',talje:'Talje',hofte:'Hofte',hoejde:'Højde',vaegt:'Vægt',
    indv_benlaengde:'Indv. benlængde',laarvidde:'Lårvidde',aermelaengde:'Ærmelængde',
    haandomkreds:'Håndomkreds',haandlaengde:'Håndlængde',haandbredde:'Håndbredde',
    hovedomkreds:'Hovedomkreds',halsomkreds:'Halsomkreds',armomkreds:'Armomkreds',
    frontlaengde:'Frontlængde',fodlaengde:'Fodlængde',mondopoint:'Mondopoint',
    alder:'Alder',str_eu:'EU',str_uk:'UK',str_us:'US',str_us_dame:'US dame',
    str_us_herre:'US herre',str_uk_dame:'UK dame',str_uk_herre:'UK herre',
    plagg_laengde:'Handskens længde',plagg_bredde:'Handskens bredde'};
  /* Hvad hedder varen, når vi taler om den i teksten */
  var KAT = {
    'Jackets':'jakken','Pants':'bukserne','Apparel Pants':'bukserne','Shorts':'shortsene',
    'Top':'overdelen','Toplayer':'overdelen','Midlayer':'midlayeren','Baselayer':'undertøjet',
    'Underwear':'undertøjet','Fleece':'fleecen','T-Shirts':'t-shirten',
    'Long Sleeve T-Shirts':'trøjen','Sweatshirts':'sweatshirten','Hoodies':'hoodien',
    'Shirts':'skjorten','Bottom':'bukserne','Wear':'tøjet','Thermo':'thermotøjet',
    'Lycra':'lycraen','Wetsuits':'våddragten','Hoods':'hætten',
    'Gloves':'handsken','Neo Gloves':'neoprenhandsken','Socks':'sokken',
    'Ski Boots':'skistøvlen','Snowboard Boots':'snowboardstøvlen','XC Boots':'langrendsstøvlen',
    'Neo Boots':'neoprenskoen','Footwear':'skoen','Inner Soles':'sålen',
    'Helmets':'hjelmen','Snow Helmets':'hjelmen','Water Helmets':'hjelmen',
    'Impact Vests':'vesten','Swim Vests':'vesten','Ponchos':'ponchoen',
    'Belts':'bæltet','Beanies':'huen','Caps':'kasketten','Neck Tubes':'halsedissen',
    'Snowboard Bindings':'bindingen'
  };
  var NOCONV = {vaegt:'kg',str_eu:'',str_uk:'',str_us:'',str_us_dame:'',str_us_herre:'',
    str_uk_dame:'',str_uk_herre:'',alder:'år',str_alt:''};
  var C = {bryst:'#2a78d6',talje:'#eb6834',hofte:'#1baf7a',indv_benlaengde:'#4a3aa7',
    aermelaengde:'#eda100',haandomkreds:'#2a78d6',hovedomkreds:'#2a78d6',mondopoint:'#2a78d6',
    fodlaengde:'#2a78d6'};

  var D = {
    HERRE: 'M50,377C48,377 47,376 44,372C38,366 39,362 45,360L47,360L47,354C47,351 46,345 45,342C38,318 37,312 37,296C38,277 37,259 34,245C33,239 32,231 32,229C32,224 31,223 30,222C28,221 28,221 28,217C29,215 29,208 29,201C30,189 31,177 33,170C33,167 34,166 33,165C32,163 32,154 33,134C33,122 33,120 32,122C32,124 31,125 30,126C28,127 25,136 25,141C24,148 21,162 17,173C11,187 11,189 14,195C16,200 17,208 17,214C17,215 17,216 18,217C20,220 12,220 8,217C4,215 3,209 4,202C4,197 4,196 3,193C2,191 2,190 3,187C4,185 4,179 4,169C4,148 5,139 8,132C11,126 11,120 10,119C8,118 8,117 9,114C10,112 11,104 12,97C15,75 15,75 33,66C41,62 43,61 45,57C47,55 49,53 50,53C53,51 53,51 52,45C51,41 50,41 49,40C46,40 43,30 45,29C46,28 46,27 45,23C44,18 44,18 44,16C45,15 46,13 46,11C47,8 51,5 54,4C56,4 58,3 59,3C71,-1 82,12 78,25C78,27 78,28 78,28C80,29 78,38 76,39C73,42 71,52 73,53C74,53 76,56 78,58C81,62 82,63 92,68C108,77 109,78 112,99C113,104 114,110 115,113C116,118 116,118 114,119C112,121 113,128 117,138C121,146 122,161 122,195C122,197 122,202 123,205C125,210 124,218 123,219C122,219 120,221 118,222C113,225 112,224 115,220C117,217 117,213 116,211C115,210 113,209 113,210C113,210 113,213 113,215C113,219 111,222 110,220C108,218 108,203 110,199C113,192 112,187 104,166C103,164 102,160 102,158C102,155 101,152 101,151C101,150 100,147 100,143C99,137 96,127 95,126C94,125 94,124 93,123C92,120 91,120 91,122C91,123 91,130 92,137C93,146 93,154 93,158C92,162 92,166 92,167C92,169 93,175 94,182C95,194 95,218 94,221C93,222 93,227 92,232C91,237 90,246 89,251C88,258 88,261 88,276C89,317 89,314 81,339C78,347 77,352 77,355C77,360 78,360 80,358C82,357 82,357 82,358C83,359 83,359 83,359C84,358 89,363 89,365C88,367 82,373 76,377C70,380 65,377 65,372C65,370 65,366 65,364C64,360 64,358 65,354C66,351 66,346 66,331C66,315 67,311 68,306C69,298 69,287 67,280C66,275 66,272 66,263C66,249 64,224 63,224C62,224 62,222 62,220L62,217L61,220C61,222 61,224 61,224C59,226 58,243 59,258C59,271 59,274 58,281C56,291 56,291 59,306C61,315 61,317 60,322C58,334 58,348 59,354C60,357 60,359 60,361C60,362 59,366 59,370C59,378 58,378 50,377ZM13,213C13,212 12,210 12,209C11,205 10,206 10,210C10,213 10,214 12,214C13,214 13,214 13,213Z',
    DAME:  'M56,377C55,376 54,375 54,373C54,371 53,368 53,367C52,365 51,365 52,363C53,362 53,360 53,359C53,358 54,355 54,353C56,348 56,347 55,334C54,324 54,314 54,304C55,292 55,288 53,280C52,273 52,271 53,264C54,254 55,232 54,227C54,224 54,223 52,224C49,224 48,240 51,263C52,271 52,273 50,280C49,287 49,290 50,304C50,317 50,323 49,331C47,345 47,350 49,356C51,362 51,365 50,367C49,368 48,370 48,373L48,377L44,377C37,377 33,371 36,366C39,363 38,355 36,342C32,321 31,319 30,310C29,303 29,298 29,285C30,267 29,259 25,241C22,225 21,224 20,224C17,223 14,201 16,191C17,176 22,156 25,147C31,134 31,136 23,106L22,103L21,107C19,119 17,130 17,136C17,139 17,143 16,144C14,151 8,179 8,186C8,187 9,191 10,194C12,198 12,199 12,207C12,212 13,216 13,217C15,219 14,219 9,218C3,215 1,211 1,200C1,196 1,183 0,172C-0,149 0,141 3,133C5,128 6,120 7,107C7,97 9,84 11,74C12,72 20,68 29,65C38,62 39,62 40,59C43,54 42,51 37,51C29,50 26,34 30,17C33,6 46,-0 57,4C68,8 70,12 70,33L69,49L67,50C65,51 63,51 61,51C58,50 58,52 60,57C61,60 63,61 76,66C85,69 91,72 92,73C94,75 95,88 96,104C97,121 98,123 100,129C103,140 104,147 103,163C103,170 102,178 102,182C102,202 102,208 100,211C99,214 91,222 90,222C89,222 89,217 90,215C91,215 91,211 91,205C91,195 91,195 93,191C95,186 94,168 88,144C87,141 86,135 86,130C85,121 82,104 80,104C78,104 73,134 75,139C76,141 77,145 78,148C88,172 92,217 85,222C84,223 83,227 81,232C75,255 74,264 74,285C75,307 74,313 68,339C66,348 65,353 65,356C65,359 65,362 65,363C64,365 64,366 66,367C69,368 69,371 67,373C66,373 66,374 66,375C66,377 60,378 56,377ZM96,207C96,206 96,205 95,205C95,205 94,206 94,207C94,208 94,210 94,211C94,213 94,213 95,211C95,210 96,209 96,207ZM9,208C9,206 8,205 8,205C7,205 7,206 7,208C9,213 10,213 9,208Z',
    HAND:  'M100,298C90,298 81,296 76,293L74,292L74,274C74,246 72,241 62,230C57,224 44,208 40,202C38,200 35,195 33,193C27,185 27,183 25,174C24,165 22,160 16,143C14,138 12,132 11,130C10,125 10,124 6,119C-1,107 0,103 10,103C23,104 34,115 39,133C45,154 46,156 52,160C58,164 59,163 62,154C67,141 68,126 65,96C65,91 65,83 65,74C65,66 64,55 64,50C63,27 64,20 69,17C77,12 84,21 84,40C84,52 85,60 87,76C89,86 90,89 90,96C91,111 92,117 95,117C97,117 97,116 97,99C96,87 96,82 97,78C98,66 98,62 99,49C99,41 100,31 100,28C100,16 100,10 103,6C107,-1 116,0 119,8L120,10L120,32C120,45 120,60 120,68C120,80 120,84 120,96C119,117 119,119 122,119C125,119 126,114 127,94C127,88 128,83 129,79C130,72 132,61 134,44C137,22 140,17 148,19C154,21 156,27 153,49C152,60 151,64 151,75C151,89 151,90 148,109C145,123 145,127 146,128C148,131 149,129 156,114C164,98 167,89 171,75C174,65 176,60 179,58C185,55 189,59 190,67C190,76 183,106 175,124C167,143 167,145 165,165C163,188 161,200 156,215C153,221 153,222 148,232C141,248 139,258 140,281C141,293 141,292 136,294C127,297 114,299 100,298ZM106,201C105,181 101,172 85,157C75,147 75,147 84,157C99,172 105,188 106,207C106,209 106,210 106,209C106,209 106,206 106,201ZM146,157C146,157 144,156 143,156C139,155 134,153 125,147C115,141 100,134 98,135C98,136 98,136 99,136C108,139 112,141 122,147C133,154 138,156 143,157C145,157 146,157 146,157C146,157 146,157 146,157ZM19,137C20,134 20,134 18,137C16,140 16,140 17,139C18,139 18,138 19,137ZM171,112C170,112 169,111 168,110C166,108 165,108 167,110C168,111 171,113 172,113C172,113 172,113 171,112ZM145,89C145,89 144,89 144,89C143,89 141,89 140,88C134,88 134,88 136,88C139,89 146,90 145,89ZM180,89C180,88 179,88 178,87C177,87 175,86 175,86C174,85 173,84 173,84C172,84 175,87 177,88C180,89 180,89 180,89ZM81,85C82,85 83,84 83,84C83,84 82,84 81,85C80,85 77,85 74,85C72,85 72,85 72,85C73,86 79,86 81,85ZM113,79C113,79 111,79 108,79C106,79 104,79 104,79C104,80 112,80 113,79ZM146,54C147,54 147,54 145,54C144,54 142,53 141,53C139,52 138,52 139,53C141,54 145,55 146,54ZM77,50C78,49 76,49 73,50C72,50 72,50 74,50C75,50 77,50 77,50ZM113,39C113,39 111,39 110,39C108,39 107,38 106,38C106,38 105,38 106,38C107,39 112,40 113,39Z',
    HEAD:  'M93,299C93,299 92,299 90,298C78,297 42,283 22,274C12,268 1,262 2,261C3,261 4,261 5,261C12,259 24,252 29,248C34,243 34,239 34,213L34,201L31,197C25,187 22,179 18,162L18,157L15,157C8,157 7,156 5,142C3,137 2,131 2,128L1,124L1,117C2,109 2,108 3,107C5,105 8,105 11,106C12,107 13,108 13,108C14,108 13,100 11,91C11,89 11,87 11,85C8,69 15,48 28,32C41,17 53,9 69,5C116,-7 158,10 176,47C182,62 185,82 183,102C183,108 183,108 185,107C188,106 190,105 191,106C194,109 193,134 188,150C187,155 183,159 179,159C177,159 177,159 177,160C177,160 176,163 176,166C173,179 169,188 163,197C162,199 161,201 161,201C160,202 160,203 160,214C159,241 160,244 172,252C180,257 186,260 191,261C193,261 194,262 194,262C191,266 164,281 150,286C126,295 103,301 93,299Z',
    FOOT:  'M58,124 C56,148 70,168 74,194 C76,216 74,238 78,256 C84,280 106,290 123,282 C138,275 143,250 141,230 C139,202 151,164 157,128 C159,114 155,104 143,104 L72,104 C62,104 58,111 58,124 Z'
  };
  var FEET_H = '<path d="M47,352 L59,352 C61,360 62,369 61,375 C60,379 43,379 41,375 C40,368 43,359 47,352 Z"/><path d="M66,352 L77,352 C81,359 84,368 83,375 C81,379 64,379 63,375 C62,369 63,360 66,352 Z"/>';
  var FEET_D = '<path d="M38,352 L48,352 C50,360 51,369 50,375 C49,378 34,378 32,375 C31,369 34,359 38,352 Z"/><path d="M55,352 L65,352 C68,359 70,368 69,375 C68,378 53,378 52,375 C51,369 52,360 55,352 Z"/>';
  var FILL = 'fill="currentColor" opacity=".2"';

  function unit(m, cm) { return NOCONV[m] !== undefined ? NOCONV[m] : (cm ? 'cm' : 'in'); }
  function conv(v, m, cm) { return (cm || NOCONV[m] !== undefined) ? v : v / 2.54; }
  function rd(v) { return Math.round(v * 10) / 10; }
  function fmt(a, m, cm) {
    var x = rd(conv(a[0], m, cm)), y = rd(conv(a[1], m, cm));
    return x === y ? String(x) : x + '-' + y;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) {
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  function band(m, inner) { return '<g class="oos-sg-b" data-m="' + m + '" opacity="0">' + inner + '</g>'; }
  function hline(m, x1, x2, y, lx) {
    var c = C[m] || '#2a78d6';
    return band(m,
      '<line x1="'+x1+'" y1="'+y+'" x2="'+x2+'" y2="'+y+'" stroke="'+c+'" stroke-width="2.5" stroke-linecap="round"/>' +
      '<line x1="'+x2+'" y1="'+y+'" x2="'+(lx-6)+'" y2="'+y+'" stroke="'+c+'" stroke-width="1" stroke-dasharray="2 3"/>' +
      '<text x="'+lx+'" y="'+(y-4)+'" font-size="11.5" class="oos-sg-lbl">'+(L[m]||m)+'</text>' +
      '<text x="'+lx+'" y="'+(y+11)+'" font-size="12.5" class="oos-sg-val" data-v="'+m+'"></text>');
  }
  function krop(d, feet, id, dx, w, ax, by, bw) {
    return '<svg viewBox="0 0 300 400" width="100%" role="img" aria-label="Kropssilhuet med målebånd">' +
      '<defs><clipPath id="'+id+'"><rect x="-20" y="-20" width="'+(w+40)+'" height="372"/></clipPath></defs>' +
      '<g transform="translate('+dx+',10)"><path fill-rule="evenodd" '+FILL+' clip-path="url(#'+id+')" d="'+d+'"/>' +
      '<g '+FILL+'>'+feet+'</g></g>' +
      hline('bryst', by[0], by[1], by[2], 158) +
      hline('talje', bw[0], bw[1], bw[2], 158) +
      hline('hofte', bw[0], bw[1], bw[3], 158) +
      band('indv_benlaengde',
        '<line x1="80" y1="215" x2="80" y2="388" stroke="'+C.indv_benlaengde+'" stroke-width="2.5" stroke-linecap="round"/>' +
        '<line x1="80" y1="388" x2="152" y2="344" stroke="'+C.indv_benlaengde+'" stroke-width="1" stroke-dasharray="2 3"/>' +
        '<text x="158" y="340" font-size="11.5" class="oos-sg-lbl">Indv. benlængde</text>' +
        '<text x="158" y="355" font-size="12.5" class="oos-sg-val" data-v="indv_benlaengde"></text>') +
      band('aermelaengde',
        '<path d="M'+ax+',98 C'+(ax+6)+',140 '+(ax+8)+',185 '+(ax+4)+',222" fill="none" stroke="'+C.aermelaengde+'" stroke-width="2.5" stroke-linecap="round"/>' +
        '<line x1="'+(ax+4)+'" y1="222" x2="152" y2="256" stroke="'+C.aermelaengde+'" stroke-width="1" stroke-dasharray="2 3"/>' +
        '<text x="158" y="252" font-size="11.5" class="oos-sg-lbl">Ærmelængde</text>' +
        '<text x="158" y="267" font-size="12.5" class="oos-sg-val" data-v="aermelaengde"></text>') +
      '</svg>';
  }
  function art(sil, koen, id) {
    if (sil === 'krop') {
      return koen === 'Dame'
        ? krop(D.DAME, FEET_D, id, 27, 106, 131, [26,134,122], [22,138,156,186])
        : krop(D.HERRE, FEET_H, id, 18, 125, 138, [20,142,125], [16,146,160,190]);
    }
    if (sil === 'haand') return '<svg viewBox="0 0 300 300" width="100%" role="img" aria-label="Håndflade med målebånd">' +
      '<g transform="translate(0,22) scale(0.85)"><path fill-rule="evenodd" '+FILL+' d="'+D.HAND+'"/></g>' +
      hline('haandomkreds',46,152,145,162) + hline('haandlaengde',46,152,90,162) + '</svg>';
    if (sil === 'hoved') return '<svg viewBox="0 0 300 300" width="100%" role="img" aria-label="Hoved med målebånd">' +
      '<g transform="translate(2,30) scale(0.8)"><path fill-rule="evenodd" '+FILL+' d="'+D.HEAD+'"/></g>' +
      band('hovedomkreds',
        '<ellipse cx="81" cy="106" rx="77" ry="14" fill="none" stroke="'+C.hovedomkreds+'" stroke-width="2.5"/>' +
        '<line x1="158" y1="106" x2="172" y2="106" stroke="'+C.hovedomkreds+'" stroke-width="1" stroke-dasharray="2 3"/>' +
        '<text x="178" y="102" font-size="11.5" class="oos-sg-lbl">Hovedomkreds</text>' +
        '<text x="178" y="117" font-size="12.5" class="oos-sg-val" data-v="hovedomkreds"></text>') + '</svg>';
    if (sil === 'fod') return '<svg viewBox="0 0 300 320" width="100%" role="img" aria-label="Fodsål med længdemål">' +
      '<g '+FILL+'><path d="'+D.FOOT+'"/>' +
      '<ellipse cx="75" cy="82" rx="15" ry="31"/><ellipse cx="101" cy="84" rx="11.5" ry="28"/>' +
      '<ellipse cx="121" cy="88" rx="10.5" ry="24"/><ellipse cx="137" cy="93" rx="9.5" ry="19"/>' +
      '<ellipse cx="148" cy="100" rx="8" ry="14"/></g>' +
      band('mondopoint',
        '<line x1="188" y1="51" x2="188" y2="286" stroke="'+C.mondopoint+'" stroke-width="2.5" stroke-linecap="round"/>' +
        '<line x1="180" y1="51" x2="196" y2="51" stroke="'+C.mondopoint+'" stroke-width="2.5" stroke-linecap="round"/>' +
        '<line x1="180" y1="286" x2="196" y2="286" stroke="'+C.mondopoint+'" stroke-width="2.5" stroke-linecap="round"/>' +
        '<text x="204" y="164" font-size="11.5" class="oos-sg-lbl">Fodlængde</text>' +
        '<text x="204" y="179" font-size="12.5" class="oos-sg-val" data-v="mondopoint"></text>') + '</svg>';
    return '';
  }

  function build(dlg) {
    var node = dlg.querySelector('[data-sg-data]');
    var body = dlg.querySelector('[data-sg-body]');
    if (!node || !body) return;
    var G;
    try { G = JSON.parse(node.textContent); } catch (e) { return; }
    if (typeof G.maal === 'string')    { try { G.maal = JSON.parse(G.maal); } catch (e) { G.maal = []; } }
    if (typeof G.raekker === 'string') { try { G.raekker = JSON.parse(G.raekker); } catch (e) { return; } }
    if (!G.raekker || !G.raekker.length) return;

    var maal = G.maal && G.maal.length ? G.maal
      : Object.keys(G.raekker.reduce(function (a, r) { for (var k in r.vaerdier) a[k] = 1; return a; }, {}));
    var cm = true;
    var sel = G.valgt || null;
    var kan = {}; (G.koebbar || []).forEach(function (s) { if (s) kan[String(s).trim()] = 1; });
    var id = dlg.id + '-clip';
    var idx = {}; G.raekker.forEach(function (r, i) { idx[String(r.stoerrelse)] = i; });
    var vare = KAT[G.kategori] || 'tøjet';
    var kanEstimere = [];

    /* ---------- Bygges én gang. Inputfelterne må aldrig genskabes. ---------- */
    function skeleton() {
      var maalbar = maal.filter(function (m) {
        return (NOCONV[m] === undefined || m === 'vaegt') && m.indexOf('plagg') !== 0;
      });
      /* Kun brystet estimeres. Talje og bryst blev estimeret hver for sig og
         pegede på hver sin størrelse, 165 cm / 60 kg gav bryst 94 (= S) og
         talje 76 (= XS), og XS vandt. Brystet er det bærende mål på overdele. */
      kanEstimere = [];
      if (maal.indexOf('bryst') >= 0 && EST[G.koen + '|bryst']) kanEstimere.push('bryst');
      /* Højde og vægt hører sammen med hjælpeteksten øverst, også når skemaet
         selv har dem som mål. Før blev de kun flyttet op hvis de manglede, så
         fx Schöffels dameskema lagde Vægt øverst og lod Højde blive stående
         nede mellem Hofte og Ærmelængde, stik imod hvad teksten lover.
         Feltet beholder sit data-m, så beregningen er uændret. */
      var hjaelp = [];
      if (kanEstimere.length) {
        ['hoejde', 'vaegt'].forEach(function (m, n) {
          var p = maalbar.indexOf(m);
          if (p >= 0) maalbar.splice(p, 1);
          maalbar.splice(n, 0, m);
          hjaelp.push(m);
        });
      }
      var harArt = G.silhuet && G.silhuet !== 'ingen';
      var harCalc = maalbar.length > 0;
      var h = '';

      function felt(m) {
        return '<label class="oos-sg__fld"><span>' + (L[m] || m) + '</span>' +
               '<input type="number" min="1" step="0.5" inputmode="decimal" autocomplete="off" data-m="' + m + '">' +
               '<em data-u="' + m + '">' + unit(m, cm) + '</em></label>';
      }

      if (harArt || harCalc) {
        h += '<div class="oos-sg__grid' + ((harArt && harCalc) ? '' : ' oos-sg__grid--solo') + '">';
        if (harArt) h += '<div class="oos-sg__art">' + art(G.silhuet, G.koen, id) + '</div>';
        if (harCalc) {
          h += '<div class="oos-sg__calc">';
          h += '<p class="oos-sg__h">Find min størrelse</p>';
          if (hjaelp.length) {
            h += '<p class="oos-sg__hint">Højde og vægt giver et bud. Mål på kroppen gør det præcist.</p>';
            hjaelp.forEach(function (m) { h += felt(m); });
            h += '<div class="oos-sg__sep"></div>';
          }
          maalbar.forEach(function (m) { if (hjaelp.indexOf(m) < 0) h += felt(m); });
          h += '<p class="oos-sg__err" data-sg-err></p>';
          h += '<div class="oos-sg__rec">' +
                 '<span class="oos-sg__rec-lbl" data-sg-lbl>Anbefalet størrelse</span>' +
                 '<strong class="oos-sg__rec-str" data-sg-rs>-</strong>' +
                 '<span class="oos-sg__rec-txt" data-sg-rw>Tast mindst ét mål ind.</span>' +
                 '<a class="oos-sg__link" data-sg-link href="#" hidden></a>' +
               '</div>';
          if (G.pasform) h += '<p class="oos-sg__fit"><span>Pasform</span>' + esc(G.pasform) + '</p>';
          h += '</div>';
        }
        h += '</div>';
      }
      if (!harCalc && G.pasform) {
        h += '<p class="oos-sg__fit oos-sg__fit--solo"><span>Pasform</span>' + esc(G.pasform) + '</p>';
      }
      h += '<div class="oos-sg__tblwrap" data-sg-tbl></div>';
      body.innerHTML = h;

      body.querySelectorAll('input[data-m]').forEach(function (i) {
        var gemt = husk.get(i.dataset.m);
        if (gemt) i.value = gemt;
        i.addEventListener('input', function () { husk.set(i.dataset.m, i.value); calc(); });
        i.addEventListener('change', calc);
      });
    }

    function table() {
      var h = '<table class="oos-sg__tbl"><thead><tr><th>Størrelse</th>';
      maal.forEach(function (m) {
        h += '<th>' + (L[m] || m) + (NOCONV[m] === undefined ? ' (' + (cm ? 'cm' : 'in') + ')' : '') + '</th>';
      });
      h += '</tr></thead><tbody>';
      G.raekker.forEach(function (r) {
        var s = String(r.stoerrelse);
        var ude = Object.keys(kan).length && !kan[s.trim()];
        h += '<tr data-s="' + esc(s) + '" class="' + (ude ? 'is-out' : '') +
             '" tabindex="0" role="button" aria-label="Vælg størrelse ' + esc(s) + '">';
        h += '<td>' + esc(s) + (ude ? ' <em>udsolgt</em>' : '') + '</td>';
        maal.forEach(function (m) {
          var v = r.vaerdier && r.vaerdier[m];
          h += '<td>' + (v ? fmt(v, m, cm) : '-') + '</td>';
        });
        h += '</tr>';
      });
      h += '</tbody></table>';
      body.querySelector('[data-sg-tbl]').innerHTML = h;
      body.querySelectorAll('tr[data-s]').forEach(function (tr) {
        function vaelg() { sel = (sel === tr.dataset.s) ? null : tr.dataset.s; paint(); }
        tr.addEventListener('click', vaelg);
        tr.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); vaelg(); }
        });
      });
    }

    /* ---------- Opdaterer kun markering og målebånd ---------- */
    function paint() {
      body.querySelectorAll('tr[data-s]').forEach(function (tr) {
        var v = tr.dataset.s === sel;
        tr.classList.toggle('is-sel', v);
        tr.setAttribute('aria-pressed', v ? 'true' : 'false');
      });
      var row = sel ? G.raekker.filter(function (r) { return String(r.stoerrelse) === sel; })[0] : null;
      body.querySelectorAll('.oos-sg-b').forEach(function (b) {
        var m = b.dataset.m, has = maal.indexOf(m) >= 0;
        b.setAttribute('opacity', !has ? '0' : (row ? '1' : '.45'));
        var t = b.querySelector('[data-v="' + m + '"]');
        if (t) {
          var v = row && row.vaerdier ? row.vaerdier[m] : null;
          t.textContent = v ? fmt(v, m, cm) + ' ' + unit(m, cm) : '';
        }
      });
    }

    function udsolgt(r) {
      return Object.keys(kan).length && !kan[String(r.stoerrelse).trim()];
    }

    /* Scorer HVER række samlet mod alle indtastede mål.
       Afstanden måles fra intervallets MIDTE, i halve intervalbredder:
         0   = præcis i midten
         1   = lige på kanten
         >1  = udenfor, og det straffes dobbelt så hårdt
       Derfor vinder M (175-180) over S (173-178) ved en højde på 178 cm -
       begge dækker målet, men 178 ligger midt i M og yderst i S. */
    function score(r, vals) {
      var sum = 0, ude = 0, brugt = 0, m, v, lo, hi, mid, half, d;
      for (m in vals) {
        v = r.vaerdier ? r.vaerdier[m] : null;
        if (!v) continue;
        brugt++;
        lo = v[0]; hi = v[1];
        mid = (lo + hi) / 2;
        half = Math.max((hi - lo) / 2, 1);
        d = Math.abs(vals[m] - mid) / half;
        if (d > 1) { sum += 1 + 2 * (d - 1); ude++; }
        else       { sum += d; }
      }
      return brugt ? { sum: sum / brugt, ude: ude, brugt: brugt } : null;
    }

    var GRAENSER = { hoejde: [110, 220], vaegt: [25, 250], bryst: [50, 170],
                     talje: [45, 170], hofte: [50, 170] };
    function calc() {
      var vals = {}, bad = '';
      body.querySelectorAll('input[data-m]').forEach(function (el) {
        el.classList.remove('is-bad');
        if (!el.value) return;
        var n = parseFloat(String(el.value).replace(',', '.'));
        var m = el.dataset.m;
        if (isNaN(n) || n <= 0) { bad = bad || 'Indtast et tal'; el.classList.add('is-bad'); return; }
        var v = (cm || NOCONV[m] !== undefined) ? n : n * 2.54;
        var gr = GRAENSER[m];
        if (gr && (v < gr[0] || v > gr[1])) {
          bad = bad || ((L[m] || m) + ' skal være mellem ' + gr[0] + ' og ' + gr[1] + ' ' + unit(m, cm));
          el.classList.add('is-bad');
          return;
        }
        vals[m] = v;
      });
      /* Omregn højde+vægt til de mål guiden bruger, men kun for dem
         kunden ikke selv har tastet ind. Egne mål vinder altid. */
      var estimeret = [], estFejl = false;
      if (vals.hoejde && vals.vaegt) {
        kanEstimere.forEach(function (m) {
          if (vals[m] != null) return;
          var e = estimer(G.koen, m, vals.hoejde, vals.vaegt);
          if (e) { vals[m] = e; estimeret.push(m); }
          else estFejl = true;
        });
      }
      /* Højden gemmes, FØR den fjernes fra scoren, den skal stadig kunne
         sætte gulvet for størrelsen længere nede. */
      var brugerHoejde = vals.hoejde || null;
      if (maal.indexOf('hoejde') < 0) delete vals.hoejde;
      if (maal.indexOf('vaegt') < 0) delete vals.vaegt;

      var err = body.querySelector('[data-sg-err]');
      var rs  = body.querySelector('[data-sg-rs]');
      var rw  = body.querySelector('[data-sg-rw]');
      if (err) err.textContent = bad || '';
      var ks = Object.keys(vals);
      if (!ks.length || bad) {
        if (rs) rs.textContent = '-';
        if (rw) rw.textContent = bad ? 'Ret målet ovenfor.' : 'Tast mindst ét mål ind.';
        var lb0 = body.querySelector('[data-sg-lbl]'); if (lb0) lb0.textContent = 'Anbefalet størrelse';
        var l0 = body.querySelector('[data-sg-link]'); if (l0) l0.hidden = true;
        return;
      }

      var best = null, bestS = null;
      G.raekker.forEach(function (r) {
        var sc = score(r, vals);
        if (!sc) return;
        if (!best) { best = r; bestS = sc; return; }
        var d = sc.sum - bestS.sum;
        if (d < -0.03) { best = r; bestS = sc; return; }          /* klart bedre pasform */
        if (d > 0.03) return;                                      /* klart dårligere */
        if (sc.ude < bestS.ude) { best = r; bestS = sc; return; }  /* færre mål udenfor */
        if (sc.ude > bestS.ude) return;
        if (udsolgt(best) && !udsolgt(r)) { best = r; bestS = sc; return; } /* på lager vinder */
        if (!udsolgt(best) && udsolgt(r)) return;
        /* Ved lige pasform: den mindste. Ellers ville fx en højde på 183 cm
           kunne ende på 3XL, bare fordi den række også dækker 183. */
        if (idx[String(r.stoerrelse)] < idx[String(best.stoerrelse)]) { best = r; bestS = sc; }
      });
      if (!best) {
        if (rs) rs.textContent = '-';
        if (rw) rw.textContent = estFejl
          ? 'Højde og vægt rækker ikke her. Tast dit brystmål ind.'
          : 'Tast mindst ét mål ind.';
        return;
      }

      /* Hvor mange rækker passer lige så godt? */
      var lige = [];
      G.raekker.forEach(function (r) {
        var sc = score(r, vals);
        if (sc && Math.abs(sc.sum - bestS.sum) < 0.03 && sc.ude === bestS.ude) lige.push(String(r.stoerrelse));
      });

      /* Højden sætter et gulv. En mand på 190 kan ikke passe en XS,
         uanset hvor slank han er, længden rækker ikke. */
      var loeftet = false, loeftFra = null;
      if (brugerHoejde) {
        var gulv = hoejdeGulv(G.koen, brugerHoejde);
        var bi = ladderIdx(best.stoerrelse);
        if (gulv != null && bi != null && bi < gulv) {
          for (var q = 0; q < G.raekker.length; q++) {
            var qi = ladderIdx(G.raekker[q].stoerrelse);
            if (qi === gulv) { loeftFra = String(best.stoerrelse); best = G.raekker[q]; loeftet = true; break; }
          }
          if (!loeftet) for (var q2 = 0; q2 < G.raekker.length; q2++) {
            var qi2 = ladderIdx(G.raekker[q2].stoerrelse);
            if (qi2 != null && qi2 >= gulv) { loeftFra = String(best.stoerrelse); best = G.raekker[q2]; loeftet = true; break; }
          }
        }
      }
      sel = String(best.stoerrelse);
      paint();
      if (rs) rs.textContent = sel;
      if (!rw) return;

      /* Forklaring. Er målene anslået, taler vi ikke om afvigelser i
         centimeter, kunden har jo ikke selv målt dem. */
      var lbl = body.querySelector('[data-sg-lbl]');
      if (lbl) lbl.textContent = estimeret.length ? 'Anslået størrelse' : 'Anbefalet størrelse';
      if (rs) rs.textContent = sel;

      var t = '';
      if (estimeret.length) {
        var em = estimeret.map(function (m) { return (L[m] || m).toLowerCase(); });
        t = 'Anslået ud fra din højde og vægt. Mål ' +
            (em.length > 1 ? em.slice(0, -1).join(', ') + ' og ' + em[em.length - 1] : em[0]) +
            ' for et sikkert svar.';
        if (loeftet) t += ' Dine mål peger på ' + loeftFra + ', men med din højde bliver ' + sel +
                          ' for kort. ' + sel + ' vil sidde løsere over kroppen.';
      } else {
        var passer = [], afvig = [], m;
        for (m in vals) {
          var v = best.vaerdier ? best.vaerdier[m] : null;
          if (!v) continue;
          var navn = (L[m] || m).toLowerCase();
          if (vals[m] >= v[0] && vals[m] <= v[1]) passer.push(navn);
          else afvig.push(navn + ' ' + rd(conv(vals[m], m, cm)) + ' ' + unit(m, cm) +
               ' ligger ' + (vals[m] < v[0] ? 'under' : 'over') + ' ' + fmt(v, m, cm) + ' ' + unit(m, cm));
        }
        if (loeftet) {
          t = 'Dine mål peger på ' + loeftFra + ', men med din højde bliver ' + loeftFra +
              ' for kort. ' + sel + ' passer i længden og vil sidde løsere over kroppen.';
        } else if (!afvig.length) {
          t = passer.length === 1
            ? 'Dit ' + passer[0] + 'mål passer i ' + sel + '.'
            : 'Alle dine mål passer i ' + sel + '.';
        } else if (passer.length) {
          t = passer.join(' og ') + ' passer i ' + sel + ', men ' + afvig.join(' og ') + '.';
          t = t.charAt(0).toUpperCase() + t.slice(1);
        } else {
          t = sel + ' er tættest på, men ' + afvig.join(' og ') + '.';
        }
      }
      if (lige.length > 1) {
        var mangler = maal.filter(function (m) {
          return NOCONV[m] === undefined && !(m in vals) && best.vaerdier && best.vaerdier[m];
        }).map(function (m) { return (L[m] || m).toLowerCase(); });
        if (mangler.length) t += ' Flere størrelser passer lige godt. Tilføj ' + mangler[0] + ' for et mere præcist bud.';
      }
      if (udsolgt(best)) t += ' ' + sel + ' er udsolgt.';
      rw.textContent = t;

      /* Link til alle varer i den anbefalede størrelse, på lager */
      var lnk = body.querySelector('[data-sg-link]');
      if (lnk) {
        if (G.kolurl && G.optnavn) {
          lnk.href = G.kolurl +
            '?filter.p.vendor=' + encodeURIComponent(G.brand || '') +
            '&filter.v.option.' + encodeURIComponent(String(G.optnavn).toLowerCase()) + '=' + encodeURIComponent(sel) +
            '&filter.v.availability=1';
          lnk.textContent = 'Se alle ' + (G.brand || '') + ' ' +
            String(G.koltitel || '').toLowerCase() + ' i ' + sel + ' på lager';
          lnk.hidden = false;
        } else {
          lnk.hidden = true;
        }
      }
    }

    var ub = dlg.querySelector('[data-sg-unit]');
    if (ub) ub.addEventListener('click', function () {
      cm = !cm;
      ub.textContent = cm ? 'cm' : 'in';
      body.querySelectorAll('input[data-m]').forEach(function (i) { i.value = ''; });
      body.querySelectorAll('[data-u]').forEach(function (e) { e.textContent = unit(e.dataset.u, cm); });
      table();
      paint();
      calc();
    });

    skeleton();
    table();
    paint();
    calc();
  }

  /* Kundens mål huskes i browseren, så de ikke skal tastes forfra på hvert produkt */
  /* Omregning fra højde og vægt til kropsmål.
     Trænet på de rækker i butikkens egne guider der har højde, vægt OG målet
     samtidig, i praksis våddragtsskemaerne. Testet ved at holde en hel guide
     ude: herre bryst rammer inden for 1,4 cm i median, herre talje 1,0 cm.
     Dame talje og hofte var for upræcise og er udeladt med vilje. */
  var EST = {
    'Herre|bryst': [103.3067, -0.3154, 0.719],
    'Herre|talje': [81.4908, -0.2776, 0.6672],
    'Dame|bryst':  [8.2039, 0.2918, 0.5038]
  };
  /* Modellen er trænet på voksne i et smalt spænd. Uden for det ekstrapolerer
     den vildt, 190 cm og 10 kg gav 50 cm bryst. Derfor både et gyldigt
     inputområde og en klemme på resultatet. */
  var TRAEN = { hoejde: [150, 205], vaegt: [40, 150] };
  var KLEM  = { 'Herre|bryst': [78, 145], 'Herre|talje': [64, 135], 'Dame|bryst': [72, 135] };
  function estimer(koen, maal, h, v) {
    var c = EST[koen + '|' + maal];
    if (!c || !h || !v) return null;
    if (h < TRAEN.hoejde[0] || h > TRAEN.hoejde[1]) return null;
    if (v < TRAEN.vaegt[0]  || v > TRAEN.vaegt[1])  return null;
    var y = c[0] + c[1] * h + c[2] * v;
    var k = KLEM[koen + '|' + maal];
    if (k && (y < k[0] || y > k[1])) return null;
    return y;
  }

  /* Typisk højde pr. størrelse, udledt af de guider der har højdemål.
     Bruges som gulv: uanset hvor slank man er, rækker en XS ikke i længden
     til en mand på 190. Vi tillader to trin under det højden peger på. */
  var LADDER = ['XXXS','XXS','XS','S','M','L','XL','XXL','3XL','4XL'];
  var HT = { 'Herre': [[2,170],[3,173],[4,177.5],[5,182],[6,186],[7,188.5]],
             'Dame':  [[1,154],[2,159],[3,164],[4,168],[5,172.5],[6,176]] };
  function ladderIdx(lbl) {
    var s = String(lbl).trim().toUpperCase()
      .replace('3XS','XXXS').replace('2XS','XXS').replace('2XL','XXL').replace('XXXL','3XL');
    var i = LADDER.indexOf(s);
    return i < 0 ? null : i;
  }
  function hoejdeGulv(koen, h) {
    var t = HT[koen];
    if (!t || !h) return null;
    if (h <= t[0][1]) return null;
    var i, idx = t[t.length - 1][0];
    for (i = 0; i < t.length - 1; i++) {
      if (h <= t[i + 1][1]) {
        var a = t[i], b = t[i + 1];
        idx = a[0] + (h - a[1]) / (b[1] - a[1]) * (b[0] - a[0]);
        break;
      }
    }
    if (h > t[t.length - 1][1]) idx = t[t.length - 1][0] + (h - t[t.length - 1][1]) / 4;
    /* Kappet ved L. Er man højere end det, er svaret en Tall-variant,
       ikke en bredere jakke, 200 cm gav ellers 3XL. */
    return Math.min(5, Math.max(0, Math.round(idx) - 2));
  }

  var husk = (function () {
    var KEY = 'oos-sg-maal', data = {};
    try { data = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { data = {}; }
    return {
      get: function (m) { return data[m]; },
      set: function (m, v) {
        if (v === '' || v == null) delete data[m]; else data[m] = String(v);
        try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
      }
    };
  })();

  function openDlg(dlg) {
    if (!dlg.__sgBuilt) { build(dlg); dlg.__sgBuilt = true; }
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest ? e.target.closest('[data-sg-open]') : null;
    if (o) { e.preventDefault(); var d = document.getElementById(o.dataset.sgOpen); if (d) openDlg(d); return; }
    var c = e.target.closest ? e.target.closest('[data-sg-close]') : null;
    if (c) { var d2 = c.closest('dialog'); if (d2) d2.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('oos-sg')) e.target.close();
  });
})();